module.exports = __webpack_public_path__ + "static/template-c97b47871cd8783748f13edbbdff401d.png";